export type NavItem = {
  label: string;
  href: string;
};

export const mainNav: NavItem[] = [
  { label: "Účetnictví", href: "/ucetnictvi" },
  { label: "Daňové poradenství", href: "/danove-poradenstvi" },
  { label: "Mzdy", href: "/zpracovani-mezd" },
  { label: "Poradna", href: "/poradna" },
  { label: "O firmě", href: "/o-firme" },
  { label: "Kontakt", href: "/kontakt" },
];

export const servicesNav: NavItem[] = [
  { label: "Účetnictví", href: "/ucetnictvi" },
  { label: "Daňové poradenství", href: "/danove-poradenstvi" },
  { label: "Zpracování mezd", href: "/zpracovani-mezd" },
];

export const companyNav: NavItem[] = [
  { label: "O firmě a týmu", href: "/o-firme" },
  { label: "Osvědčení a certifikáty", href: "/osvedceni-a-certifikaty" },
  { label: "Dokumenty ke stažení", href: "/dokumenty-ke-stazeni" },
  { label: "Poradna", href: "/poradna" },
  { label: "Kontakt", href: "/kontakt" },
];

export const legalNav: NavItem[] = [
  { label: "Ochrana osobních údajů", href: "/ochrana-osobnich-udaju" },
];
